module.exports = __webpack_public_path__ + "static/media/battery-empty.b0fdcd56.svg";